import GameParameterInterface from '@/models/game/parameters/interface'

interface BalloonLotteryParameter {
  prize: BalloonGamePrize
}

interface BalloonGamePrize {
  prizeImage: string,
}

export default class BalloonParameter implements GameParameterInterface {
  constructor(private parameter: BalloonLotteryParameter) { }

  createSetOption(): BalloonLotteryParameter {
    return {
      prize: this.parameter.prize,
    }
  }

  get guideUrl(): string {
    return ''
  }
}
